import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import { Paths } from "../router/Paths";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setPackageData } from "../reducer/tourReducer";
import { usePackage } from "../hooks/usePackage";
import { addActiveTab } from "../reducer/sideBarSlice";
import LocationFinder from "../components/common/LocationFinder";
import { resetTourEdit } from "../reducer/tourEditReducer";

const TourManagementPackageLocationPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locations = useLocation();

  const { packageData } = useSelector((state: RootState) => state.tour);
  const [location, setLocation] = useState<any>(null);
  const { createPrePackage } = usePackage();
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const { PrepackageDataId } = useSelector((state: RootState) => state.tour);
  const { tourEdit, id } = useSelector((state: RootState) => state.edit);
  const [center, setCenter] = useState({
    lat: packageData.meetingPoint?.latitude || 51.5074,
    lng: packageData.meetingPoint?.longitude || -0.1278,
  });
  const [city, setCity] = useState(packageData.city || "");
  const [country, setCountry] = useState(packageData.country || "");
  const [error, setError] = useState("");

  console.log("packagedata", packageData);

  const progressref = useRef(3);

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.keyCode === 13) {
        handleAdd();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [location]);

  useEffect(() => {
    if (locations.state && locations.state.packageData) {
      dispatch(setPackageData(locations.state.packageData));
    }
  }, [locations.state, dispatch]);

  // const suggestions = ["Naples, Italy", "London, UK"];

  const onContinue = () => {
    if (!packageData.locations || packageData.locations.length === 0) {
      setError("Please add at least one location.");
      return;
    }
    setError("");
    dispatch(addActiveTab(Paths.tourManagementPackageKeywords));
    navigate(Paths.tourManagementPackageKeywords);
  };

  const onSave = async () => {
    if (!packageData.locations || packageData.locations.length === 0) {
      setError("Please add at least one location.");
      return;
    }
    setError("");

    const updatedPackageData = {
      ...packageData,
      _id: PrepackageDataId,
      progress: Number(progressref.current),
    };

    const updatedPackageData2 = {
      ...packageData,
    };

    dispatch(setPackageData(updatedPackageData));
    setLoading(true);

    try {
      if (tourEdit) {
        dispatch(resetTourEdit());
        dispatch(setPackageData(updatedPackageData2));
        navigate(Paths.manageProductDetails.replace(":id", id), {
          state: { fromEdit: true },
        });
        return;
      } else {
        await createPrePackage(updatedPackageData);
      }

      localStorage.setItem("packageData", JSON.stringify(updatedPackageData));
      navigate(Paths.welcome);
    } catch (error) {
      console.error("Error saving package:", error);
      setError("Failed to save the package. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveLocation = (index: number) => {
    const data = packageData?.locations ? [...packageData?.locations] : [];
    const filteredData = data.filter((_, idx) => idx !== index);
    dispatch(
      setPackageData({
        locations: filteredData,
      })
    );
  };

  const handleAdd = () => {
    if (!location) return;

    const data = packageData?.locations
      ? [...packageData?.locations, location.label]
      : [location.label];

    dispatch(
      setPackageData({
        locations: data,
        city: city || packageData.city, // Ensure city is updated
        country: country || packageData.country, // Ensure country is updated
      })
    );
    setLocation(null);
  };

  const handleSuggestionClick = (suggestion: string) => {
    let data = packageData?.locations || [];
    if (!data.includes(suggestion)) {
      data = [...data, suggestion];
      dispatch(
        setPackageData({
          locations: data,
        })
      );
    }
  };

  const handleBack = () => {
    navigate(Paths.tourManagementPackageDescription);
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementSidebar selected={4} />

        <div className={Classname.detail}>
          <span className={Classname.title}>Where will customers visit?</span>
          <p className={Classname.description}>
            List all the major cities, sites, and attractions that your
            customers will visit during your experience. Add as many relevant
            locations as possible.
          </p>

          <div className="flex gap-4 justify-between lg:gap-12 items-center">
            <div className="w-full">
              <LocationFinder
                value={location}
                setValue={setLocation}
                setCity={setCity}
                setCountry={setCountry}
                setCenter={(newCenter) =>
                  setCenter({
                    lat: newCenter.latitude,
                    lng: newCenter.longitude,
                  })
                }
                setSuggestions={setSuggestions}
              />
            </div>

            <button
              className="bg-primary h-12 lg:h-14 px-3 lg:px-4 rounded-lg text-sm lg:text-base flex items-center justify-center text-white font-bold w-24"
              onClick={handleAdd}
            >
              + Add
            </button>
          </div>

          {error && <span className="mt-2 text-red-600">{error}</span>}

          <div className={Classname.suggestionContainer}>
            {packageData?.locations?.map((location, index) => (
              <div
                className={Classname.location}
                key={index}
                onClick={() => handleRemoveLocation(index)}
              >
                <span>{location}</span>
                <img
                  src="/IconMinus.svg"
                  alt="Remove location"
                  className="h-5 w-5 object-contain"
                />
              </div>
            ))}
          </div>

          <span className="mt-10 text-gray-500">SUGGESTIONS</span>
          <div>
            {/* <span>Dynamic Suggestions:</span> */}
            <div>
              {suggestions.length > 0 ? (
                suggestions.map((suggestion, index) => (
                  <div
                    key={index}
                    className={Classname.suggestion}
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion}
                  </div>
                ))
              ) : (
                <p>No suggestions available.</p>
              )}
            </div>
          </div>
          <div className="flex justify-between items-centers mt-10">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              {!tourEdit && (
                <button
                  className={Classname.continueButton}
                  onClick={onContinue}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourManagementPackageLocationPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 px-3 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex flex-1 h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  suggestionContainer: "flex flex-wrap gap-4 mt-4",
  suggestion:
    "text-primary1 text-sm border border-primary1 px-3 py-1 rounded-md",
  location:
    "text-primary1 text-sm border border-primary1 px-3 py-1 rounded-md cursor-pointer flex items-center gap-2",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  highlightButton:
    "font-bold flex items-center gap-2 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
